import { useMemo } from 'react'
import { Invoice } from 'types'

interface FilterOperators {
  field: string
  operator: string
  value: string
}

export const useFiltersFormDefaultValues = (invoices: Invoice[], filters: string) => {
  return useMemo(
    () => {
      const defaultFilters:FilterOperators[] = JSON.parse(filters || '[]')
    
      return defaultFilters?.reduce((acc, cur) => {
        const {field, operator, value} = cur
        return {
          ...acc,
          ...(field === 'date' && operator === 'gteq' && {
            startDate: new Date(value)
          }),
          ...(field === 'date' && operator === 'lteq' && {
            endDate: new Date(value)
          }),
          ...(field === 'customer_id' && {
            customer: invoices[0]?.customer
          }),
        }
      }, {}) || {}
    },
    [invoices, filters]
  )
}
export default useFiltersFormDefaultValues


